import { render } from "./BlListFilterSelectManyToMany.vue?vue&type=template&id=48b9791e&scoped=true"
import script from "./BlListFilterSelectManyToMany.vue?vue&type=script&lang=js"
export * from "./BlListFilterSelectManyToMany.vue?vue&type=script&lang=js"

import "./BlListFilterSelectManyToMany.vue?vue&type=style&index=0&id=48b9791e&scoped=true&lang=scss"

import exportComponent from "/tmp/3a52593b-0c57-4976-8665-ec4c8a4d9b76/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b9791e"]])

export default __exports__